export default __webpack_public_path__ + "static/media/ice-melt-award.8a9b765b.png";